import { Grid, Text, Container, Title, Image, Button } from "@mantine/core";

const SectionThree = () => {
  //const theme = useMantineTheme();

  return (
    <section id="section-three">
      <Container>
        <Grid justify="space-around">
          <Grid.Col xs={6} sm={4} md={4} lg={4}>
            <Image
              src={require("../Images/image-2.png")}
              alt={"sample2"}
              style={{ width: "100%" }}
            />
          </Grid.Col>
          <Grid.Col xs={6} sm={8} md={8} lg={8}>
            <div style={{ marginBottom: 20 }}>
              <Text color="black">
                <Title order={1}>Decentralized Data Storage</Title>
                Your health records are stored on a secure and decentralized
                data network, meaning no central authority has access to them.
                This makes it easy for you to securely share your medical
                information with doctors or other medical professionals without
                putting your privacy or security at risk.
              </Text>
            </div>
            {/* <Button color="yellow">Tell me more</Button> */}
          </Grid.Col>
        </Grid>
      </Container>
    </section>
  );
};

export default SectionThree;
